import { Layer, Shape } from '../../../../context/context';
import { defaultLayer } from '../../../../context/defaults';

interface ImportKMLProps {
    global: {
        activeLayerId: number | null;
        mapLayers: Layer[];
        setLayers: (layers: Layer[] | ((prev: Layer[]) => Layer[])) => void;
        setActiveLayerId: (id: number) => void;
    };
    editLayer: (layer: Layer, layerId: number) => void;
    setShouldFitBounds: (should: boolean) => void;
}

/**
 * Handle importing KML shapes into the map
 * Creates a new layer if needed or adds to existing active layer
 */
export function handleImportKMLShapes(
    shapes: Shape[],
    { global, editLayer, setShouldFitBounds }: ImportKMLProps
) {
    let layerIdToUse = global.activeLayerId;
    let layers = global.mapLayers;

    // Create new layer if needed
    if (layers.length === 0 || layerIdToUse == null || layers.find(l => l.layerId === layerIdToUse) == null) {
        const newLayerId = layers.length > 0 ? Math.max(...layers.map(l => l.layerId)) + 1 : 0;
        const newLayer: Layer = {
            ...defaultLayer,
            layerId: newLayerId,
            layerName: `KML Import ${newLayerId + 1}`,
            shapes: shapes,
        };
        global.setLayers((prev: Layer[]) => [...prev, newLayer]);
        global.setActiveLayerId(newLayerId);
        setShouldFitBounds(true);
        return;
    }

    // Add to existing layer
    const layer: Layer = layers.find(l => l.layerId === layerIdToUse)!;
    const newShapes: Shape[] = [...layer.shapes, ...shapes];
    const newLayer: Layer = {
        ...layer,
        shapes: newShapes
    };
    editLayer(newLayer, layerIdToUse);
    setShouldFitBounds(true);
} 